import React from 'react';
export function WeightLossConsent() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-[#f8faff] dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-1203">
      <section className="pt-32 pb-16 px-6" data-id="element-1204">
        <div className="container mx-auto max-w-4xl" data-id="element-1205">
          <h1 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-1206">
            <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-1207">
              Weight Loss Consent
            </span>
          </h1>

          <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-1208">
            <div className="space-y-6 text-gray-700 dark:text-gray-300" data-id="element-1209">
              <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl border border-gray-200 dark:border-gray-600" data-id="element-1210">
                <p className="font-semibold uppercase leading-relaxed" data-id="element-1211">
                  BY CLICKING "I AGREE," CHECKING A RELATED BOX TO SIGNIFY YOUR
                  ACCEPTANCE, USING ANY OTHER ACCEPTANCE PROTOCOL PRESENTED
                  THROUGH THE SERVICE OR OTHERWISE AFFIRMATIVELY ACCEPTING THIS
                  CONSENT, YOU ACKNOWLEDGE THAT YOU UNDERSTAND THE RISKS AND
                  POTENTIAL BENEFITS OF STARTING A WEIGHT LOSS PROGRAM.
                </p>
              </div>

              <h2 className="text-2xl font-bold mb-4" data-id="element-1212">
                Informed Consent Related to Treatment of Weight Loss Conditions
                Through Telehealth
              </h2>

              <div data-id="element-1213">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1214">Purpose</h3>
                <p className="leading-relaxed" data-id="element-1215">
                  The purpose of this informed consent form is to make sure you
                  are aware of the potential benefits - and risks - of starting
                  a weight loss program.
                </p>
              </div>

              <p className="leading-relaxed" data-id="element-1216">
                It is vitally important for you to advise your assigned health
                provider(s) contracting with JoinOmu of ANY concerns, problems,
                complaints, symptoms, or questions even if you may think it
                isn't important, so your provider can determine the best course
                of treatment. Keeping your health care provider(s) informed of
                any questions or symptoms you have affords the best chance of
                providing you with necessary information.
              </p>

              <div data-id="element-1217">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1218">
                  Potential Benefits
                </h3>
                <p className="leading-relaxed mb-3" data-id="element-1219">
                  Medically significant weight loss (usually about 10 percent of
                  initial weight, or as an example, losing 20 pounds from 200
                  pounds starting weight) can:
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-1220">
                  <li data-id="element-1221">
                    Lower blood pressure, reducing the risks of hypertension;
                  </li>
                  <li data-id="element-1222">
                    Lower cholesterol, reducing the risks of heart and vascular
                    disease;
                  </li>
                  <li data-id="element-1223">Lower blood sugar, reducing the risks of diabetes</li>
                </ul>
                <p className="leading-relaxed" data-id="element-1224">
                  If you are taking medications for one or more of these
                  conditions, dosages may need to be adjusted as your overall
                  health improves. You agree to see your primary care provider,
                  if you have one, as needed to have your need for these
                  medications reassessed, if applicable. Other benefits may also
                  be obtained but cannot be guaranteed. Increasing activity
                  level can favorably affect the above conditions and may have
                  the additional benefit of helping you sustain weight loss.
                  Weight loss and increased activity may provide important
                  psychological and social benefits, as well.
                </p>
              </div>

              <div data-id="element-1225">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1226">
                  Possible Side Effects and Risks
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-1227">
                  The possibility always exists in medicine that the combination
                  of any significant disease with methods employed for its
                  treatment may lead to previously unobserved or unexpected ill
                  effects, including death. Should one or more of these ill
                  effects occur, additional medical or surgical treatment may be
                  necessary. In addition, it is conceivable that other side
                  effects could occur, which have not yet been diagnosed or
                  observed.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1228">Reduced Weight</h4>
                <p className="leading-relaxed mb-4" data-id="element-1229">
                  When you reduce the number of calories you eat to a level
                  lower than the number of calories your body uses in a day, you
                  lose weight. As a result of this weight loss, your body makes
                  some other adjustments in body processes. Some of these
                  adjustments are responsible, in some participants, for
                  improvements in blood pressure and blood sugar. However, you
                  also may experience other temporary side effects or
                  discomforts, including an initial loss of body fluid through
                  increased urination, momentary dizziness, a reduced metabolic
                  rate or metabolism (the rate at which you convert food to
                  energy), sensitivity to cold, a slower heart rate, dry skin,
                  fatigue, diarrhea or constipation, bad breath, muscle cramps,
                  a change in menstrual pattern, dry and brittle hair or hair
                  loss. Generally, these responses are temporary and resolve
                  when calories are increased after the period of weight loss.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1230">
                  Reduced Potassium Levels
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-1231">
                  Low potassium levels can cause serious heart irregularities.
                  When someone has been on a reduced calorie diet, a rapid
                  increase in calorie intake, especially overeating or
                  binge-eating, can be associated with bloating, fluid
                  retention, disturbances in salt and mineral balance, or
                  gallbladder attacks and abdominal pain.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1232">Gallstones</h4>
                <p className="leading-relaxed mb-4" data-id="element-1233">
                  Overweight people develop gallstones at a rate higher than
                  normal weight individuals. The occurrence of symptomatic
                  gallstones (pain, diagnosed stones and/or surgery) in
                  individuals 30 percent or more over desirable body weight (50
                  pounds or more overweight) not undergoing current treatment
                  for obesity is estimated to be 1 in 100 annually, and for
                  individuals who are 20-30 percent overweight, about one-half
                  that rate, or 1 in 200 annually. It is possible to have
                  gallstones and not know it. One study of individuals entering
                  a weight loss program showed that as many as 1 in 10 had
                  "silent" gallstones at the onset. As body weight and age
                  increase, so do the chances of developing gallstones. These
                  chances double for women, women using estrogen, and smokers.
                  Losing weight--especially rapidly--may increase the chances of
                  developing stones or sludge and/or increasing the size of
                  existing stones within the gallbladder. The most common
                  symptoms of gallstones are fever, nausea, and a cramping pain
                  in the right upper abdomen. If you develop any of these
                  symptoms or if you know or suspect that you may already have
                  gallstones, let your JoinOmu assigned provider and your
                  primary care provider know immediately. Gallbladder problems
                  may require medication or surgery to remove the gallbladder,
                  and, less commonly, may be associated with more serious
                  complications of inflammation of the pancreas or even death.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1234">Pancreatitis</h4>
                <p className="leading-relaxed mb-4" data-id="element-1235">
                  Pancreatitis, or an inflammation or infection in the bile
                  ducts, may be associated with the presence of gallstones and
                  the development of sludge or obstruction in the bile ducts.
                  The symptoms of pancreatitis include pain in the left upper
                  abdominal area, nausea, and fever. Pancreatitis may be
                  precipitated by binge-eating or consuming a large meal after a
                  period of dieting. Also associated with pancreatitis is a
                  long-term abuse of alcohol and the use of certain medications
                  and increased age. Pancreatitis may require surgery and may be
                  associated with more serious complications and death.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1236">Pregnancy</h4>
                <p className="leading-relaxed mb-4" data-id="element-1237">
                  If you become pregnant, you should immediately stop any and
                  all of your weight loss medications, and report this to your
                  JoinOmu assigned provider and your primary care provider, if
                  applicable, immediately. Your diet must be changed promptly to
                  avoid further weight loss because a restricted diet could be
                  damaging for a developing fetus. You must take precautions to
                  avoid becoming pregnant during the course of weight loss.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1238">
                  Binge Eating Disorders
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-1239">
                  Binge eating disorder is defined as the habitual, uncontrolled
                  consumption of a large amount of food in a short period of
                  time. Participation in a calorically restricted diet has been
                  shown in one study to increase binge eating episodes
                  temporarily. Several other studies have demonstrated reduced
                  episodes of binge eating following a calorie deficit and
                  portion-controlled diet. Extended binge eating episodes are
                  associated with weight gain.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1240">
                  The Risk of Weight Regain
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-1241">
                  Obesity is a chronic condition, and the majority of overweight
                  individuals who lose weight have a tendency to regain all or
                  some of it over time. Factors that help to maintain a reduced
                  body weight include regular physical activity, adherence to a
                  restricted calorie, low fat diet, and planning a strategy for
                  coping with weight regain before it occurs. Successful
                  treatment may take months or even years.
                </p>

                <h4 className="text-lg font-semibold mb-2" data-id="element-1242">Sudden Death</h4>
                <p className="leading-relaxed" data-id="element-1243">
                  Patients with severe obesity, particularly those with serious
                  hypertension, coronary artery disease, or diabetes mellitus,
                  have a statistically higher chance of suffering sudden death
                  when compared to normal weight people without such medical
                  problems.
                </p>
              </div>

              <div data-id="element-1244">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1245">Informed Consent</h3>
                <p className="leading-relaxed" data-id="element-1246">
                  By using JoinOmu, attending telehealth visits with a provider
                  assigned to you by JoinOmu, and receiving treatments
                  facilitated by JoinOmu you are indicating that you have
                  reviewed this Weight Loss Consent Form or had it explained to
                  you, that you understand the risks and potential benefits of
                  starting a weight loss program, that you have been given the
                  opportunity to ask questions and that such questions have been
                  answered to your satisfaction, that you have been given the
                  opportunity to exercise your opt-out rights where appropriate,
                  and that you consent to receiving the Services from licensed
                  health care providers employed by or contracted with JoinOmu,
                  Inc. who are located at sites remote from you. If you have any
                  questions, please email{' '}
                  <a href="mailto:ryan@joinomu.com" className="text-[#C85A15] hover:text-[#FF8A3D] underline" data-id="element-1247">
                    ryan@joinomu.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}